<template>
   <div>
       <!-- 版权说明 -->
   </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },

    mounted() {

    },

    methods: {
    }

}

</script>
<style scoped>
</style>
